import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  ano: string = '';

  constructor(private location: Location) { }
  

      ngOnInit() {
        this.ano = new Date().getFullYear().toString();
    }



}

